//import {Row} from 'antd';
import {
  Row,
  Col,
  Form,
 
  Select,

  TimePicker
} from "antd";
import classes from "../Pages.module.css";
import DataField from "./DataField";
//import BoonkigSizeEdit from './BookingSizeEdit';
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import dayjs from "dayjs"; // Using Day.js instead of Moment
// import TaxNew from "./UserNew";
// import dayjs from 'dayjs';
//import { useState, useEffect, useContext} from 'react';
const { Option } = Select;

const ChargeType = (props) => {

  console.log(props, "this is the props form charge type ");

  // const DisableFunction = (index, value) => {
  //   setDisabledRows((prevDisabled) => {
  //     // If charge_code is 1, add index to disabledRows; otherwise, remove it
  //     console.log(props.data[index]?.charge_code);
  //     if (value === 1) {
  //       return [...prevDisabled, index];
  //     } else {
  //       return prevDisabled.filter((i) => i !== index);
  //     }
  //   });
  // };

  const handleValueChanges = (changedValues, allValues) => {
    props.setData((data) => {
      return {
        ...data,
        taxDet: allValues.taxDet,
      };
    });
    // console.log( allValues.taxDet);
  };

  // Initialize with empty array if props.data is null/undefined
  // Convert time strings to dayjs objects for form initialization
  const data = Array.isArray(props.data) && props.data.length > 0
    ? props.data.map(item => ({
      ...item,
      from_time: item?.from_time ? dayjs(item.from_time, 'HH:mm') : null,
      to_time: item?.to_time ? dayjs(item.to_time, 'HH:mm') : null
    }))
    : [];
  console.log("ChargeType data:", data);

  return props.editMode ? (
    <Form
      layout="vertical"
      name="filter_form"
      onValuesChange={handleValueChanges}
      autoComplete="off"
      initialValues={{ taxDet: data }}
    >
      <Form.List name="taxDet">
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                <Row gutter={8}>
                  {/* <Col lg={4} md={24}> */}
                    {/* <Form.Item
                      {...restField}
                      name={[name, "unit_code"]}
                      fieldKey={[fieldKey, "unit_code"]}
                      label={
                        name === 0 ? (
                          <div
                            style={{
                              padding: "0rem 0.5rem",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                          // className={classes["Label"]}
                          >
                            Site <span style={{ color: "red" }}> *</span>
                          </div>
                        ) : null
                      }
                    >
                      <Select
                        // onChange={(value) => DisableFunction(index, value)}
                        bordered={true}
                        style={{
                          width: "100%",
                          textAlign: "left",
                          float: "left",
                          backgroundColor: "white",
                          color: "#1777C4",
                          fontWeight: "bold",
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                        placeholder="Select"
                        optionFilterProp="children"
                      >
                        {props.ad.site.rows.map((option) => {
                          return (
                            <Option
                              style={{
                                textTransform: "capitalize",
                                color: "#1777C4",
                              }}
                              key={option[props.ad.site.fields[0].name]}
                              value={
                                option[props.ad.site.fields[0].name]
                              }
                            >
                              {option[props.ad.site.fields[1].name]}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item> */}
                    {/* Log the charge_code for testing */}
                 
                  {/* </Col> */}



                  <Col
                    lg={5}
                    md={24}
                  // style={{ display: "flex", flex: "0 0 7.5%" }}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "module"]}
                      fieldKey={[fieldKey, "module"]}
                      label={
                        name === 0 && (
                          <div
                            style={{
                              padding: "0rem 0.5rem",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                              whiteSpace: "nowrap",
                            }}
                            className={classes["Label"]}
                          >
                            Module <span style={{ color: "red" }}> *</span>
                          </div>
                        )
                      }
                    // rules={[{ required: true, message: "Missing Name" }]}
                    >
                      <Select
                        bordered={true}
                        style={{
                          width: "100%",
                          textAlign: "left",
                          float: "left",
                          backgroundColor: "white",
                          color: "#1777C4",
                          fontWeight: "bold",
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                        placeholder="Select"
                        optionFilterProp="children"
                        disabled={
                          String(props.data[index]?.charge_code) === "1"
                        }
                      >
                        {props.ad.module.rows.map((option) => {
                          return (
                            <Option
                              style={{
                                textTransform: "capitalize",
                                color: "#1777C4",
                              }}
                              key={option[props.ad.module.fields[0].name]}
                              value={
                                option[props.ad.module.fields[0].name]
                              }
                            >
                              {option[props.ad.module.fields[1].name]}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={4} md={24}>
                    <Form.Item
                      {...restField}
                      name={[name, "from_time"]}
                      fieldKey={[fieldKey, "from_time"]}
                      label={
                        name === 0 ? (
                          <div
                            style={{
                              padding: "0rem 0.5rem",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                            }}
                            className={classes["Label"]}
                          >
                            From Time <span style={{ color: "red" }}> *</span>
                          </div>
                        ) : null
                      }
                      rules={[
                        { required: true, message: "Please select a time!" }, // Validation for the field
                      ]}
                    >
                      <TimePicker
                        format="HH:mm"
                        placeholder="Select time"
                        value={props.data[name]?.from_time ? dayjs(props.data[name].from_time) : null}
                        style={{ width: "100%" }}
                      />
                    </Form.Item>
                  </Col>


                  <Col lg={4} md={24}>
                    <Form.Item
                      {...restField}
                      name={[name, "to_time"]}
                      fieldKey={[fieldKey, "to_time"]}
                      label={
                        name === 0 ? (
                          <div
                            style={{
                              padding: "0rem 0.5rem",
                              fontSize: "0.7rem",
                              fontWeight: "bold",
                            }}
                            className={classes["Label"]}
                          >
                            To Time <span style={{ color: "red" }}> *</span>
                          </div>
                        ) : null
                      }
                      rules={[
                        { required: true, message: "Please select a time!" }, // Validation for the field
                      ]}
                    >
                      {/* <TimePicker
      format="HH:mm"
      placeholder="Select time"
      style={{
        width: "100%",
      }}
    /> */}
                      {/*  
<TimePicker
  format="HH:mm"
  placeholder="Select time"
  value={props.data[name]?.from_time ? dayjs(props.data[name].from_time) : null}
  style={{ width: "100%" }}
/> */}



                      <TimePicker
                        format="HH:mm"
                        placeholder="Select time"
                        value={props.data[name]?.to_time ? dayjs(props.data[name].to_time) : null}
                        style={{ width: "100%" }}
                      />




                    </Form.Item>
                  </Col>



                  <Col lg={1} md={24}>
                    {name !== 0 && (
                      <MinusCircleOutlined
                        className={classes["Remove"]}
                        onClick={() => remove(name)}
                      />
                    )}
                  </Col>

                  <Col lg={1} md={24}>
                    <PlusCircleOutlined
                      className={classes["Add"]}
                      onClick={() => {
                        add();
                      }}
                    />
                  </Col>
                </Row>
              ))}
            </>
          );
        }}
      </Form.List>
    </Form>
  ) : (
    <>
      {data.map((item, index) => {
        return (
          <div key={index}>
            <p></p>
            <Row
              className={props.editMode ? classes["RowDEX"] : classes["RowD"]}
            >
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.CHARGE_CODE}
                type="Select"
                name="CHARGE NAME"
                value={data.charge_code}
              />
              <DataField
                editMode={false}
                lg={12}
                md={24}
                name="CHARGE VALUE"
                value={data.igst}
              />
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.CHARGE_TYPE}
                type="Select"
                name="CHARGE TYPE"
                value={data.charge_type}
              />
              <DataField
                editMode={false}
                lg={12}
                md={24}
                options={props.ad.CHARGE_TYPE_ON}
                type="Select"
                name="ON"
                value={data.charge_type_on}
              />
              <DataField
                editMode={false}
                lg={8}
                md={24}
                options={props.ad.REF_CHARGE}
                type="Select"
                name="REFFRED CHARGE"
                value={data.ref_charge}
              />
              <DataField
                editMode={false}
                lg={8}
                md={24}
                options={props.ad.REF_ON}
                type="Select"
                name="ON"
                value={data.ref_on}
              />
              <DataField
                editMode={false}
                lg={8}
                md={24}
                options={props.ad.USE_FOR}
                type="Select"
                name="USED FOR"
                value={data.use_for}
              />
              <DataField
                editMode={false}
                lg={8}
                md={24}
                options={props.ad.DEAL_TYPE}
                type="Select"
                name="DEAL TYPE"
                value={data.deal_type}
              />
              <DataField
                editMode={false}
                lg={8}
                md={24}
                options={props.ad.INCLUDE_COST}
                type="Select"
                name="INCLUDE IN COST"
                value={data.include_cost}
              />
            </Row>
            <p></p>
          </div>
        );
      })}
    </>
  );
};

export default ChargeType;
